export default __webpack_public_path__ + "static/media/marker-label-CFA.0515d7c9.svg";